/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BranchLocationModel } from '../../models/branch-location-model';

export interface PromotionalLinkParentFhirIdBranchLocationsGet$Params {
  parentFhirId: string;
}

export function promotionalLinkParentFhirIdBranchLocationsGet(http: HttpClient, rootUrl: string, params: PromotionalLinkParentFhirIdBranchLocationsGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<BranchLocationModel>>> {
  const rb = new RequestBuilder(rootUrl, promotionalLinkParentFhirIdBranchLocationsGet.PATH, 'get');
  if (params) {
    rb.path('parentFhirId', params.parentFhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<BranchLocationModel>>;
    })
  );
}

promotionalLinkParentFhirIdBranchLocationsGet.PATH = '/PromotionalLink/{parentFhirId}/BranchLocations';
